import React, { FC, PropsWithChildren } from 'react'
import { Flex } from '@moonpig/launchpad-components'
import { spacingPx, theme } from '@moonpig/launchpad-theme'
import { ProductModule } from '../types'

export const ColumnModule: FC<PropsWithChildren<ProductModule>> = ({
  children,
  ...props
}) => {
  if (!children) {
    return null
  }

  return (
    <Flex
      flexWrap="wrap"
      justifyContent="center"
      px={{ xs: 0, md: 8 }}
      gap={spacingPx(8)({ theme })}
      {...props}
    >
      {Array.isArray(children)
        ? children.map((child, index) => (
            <Flex
              flex={{ xs: 'inherit', md: 1 }}
              width={{ xs: 1, md: 1 / children.length }}
              maxWidth={`${1200 / children.length}px`}
              justifyContent="center"
              // eslint-disable-next-line react/no-array-index-key
              key={`column-${index}`}
            >
              {child}
            </Flex>
          ))
        : children}
    </Flex>
  )
}
